import { ReactNode } from 'react'

import { Profession } from '@bemlo/enums'

import { Group } from '../rows/Group'

type Team = {
  id: string
  name: string
  roles: {
    id: string
    name: string
    unitId: string
    professions: Profession[]
  }[]
}

type TeamsProps = {
  teams: Team[]
  children: (props: { team: Team }) => ReactNode
}

export const TeamsLayout = (props: TeamsProps) => {
  if (props.teams.length === 0) return null

  if (props.teams.length === 1) {
    return props.children({ team: props.teams[0] })
  }

  return props.teams.map((team) => {
    return (
      <Group key={team.id} id={team.id} title={team.name} isTeam>
        {props.children({ team })}
      </Group>
    )
  })
}
